import { render } from "./ReportProcessingHistory.vue?vue&type=template&id=2f9f11c7&scoped=true"
import script from "./ReportProcessingHistory.vue?vue&type=script&lang=js"
export * from "./ReportProcessingHistory.vue?vue&type=script&lang=js"

import "./ReportProcessingHistory.vue?vue&type=style&index=0&id=2f9f11c7&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f9f11c7"]])

export default __exports__